import angular from 'angular';

import renderComponent from './render-component';
import colorizer from './colorizer';
import gridHelpers from './grid-helpers';
import dynamicText from './dynamic-text';

export default angular.module('dbm.dashboard.shared', [renderComponent, colorizer, gridHelpers, dynamicText]).name;



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/shared/index.js